import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { FaCheckCircle, FaEye } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  completeBookingByOwner,
  cleanOrdersStatus,
  fetchOrders,
} from "../../redux/Slice/carSlice";
import { FaLocationDot } from "react-icons/fa6";
import { toast } from "react-toastify";
import { MdOutlinePaid } from "react-icons/md";

const OrdersCard = ({
  bookingData,
  bookingId,
  carImage,
  carName,
  carLocation,
  carPrice,
  tripStart,
  tripEnd,
  bookingStatus,
}) => {
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const OrdersStatus = useSelector((state) => state?.car?.OrdersStatus);
  const dispatch = useDispatch();
  const [isModalVisible, setModalVisible] = useState(false);
  const [bookingDataModal, setBookingDataModal] = useState("");

  const formatDateTime = (dateTimeString) => {
    // Check if the string ends with "GMT"
    if (dateTimeString.endsWith(" GMT")) {
      // Remove " GMT" from the date string
      dateTimeString = dateTimeString.replace(" GMT", "");
    }

    // Convert the date-time string to a Date object
    const dateTime = new Date(dateTimeString);

    // Formatting the date
    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = dateTime.toLocaleDateString("en-US", dateOptions);

    // Formatting the time
    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    const formattedTime = dateTime.toLocaleTimeString("en-US", timeOptions);

    return { date: formattedDate, time: formattedTime };
  };

  // Format start date
  const formattedStartDate = formatDateTime(tripStart);

  // Format end date
  const formattedEndDate = formatDateTime(tripEnd);

  const bookingSummaryModal = (data) => {
    setModalVisible(!isModalVisible);
    setBookingDataModal(data);
  };

  const approveHandler = (bookingId) => {
    dispatch(completeBookingByOwner({ bookingId: bookingId }));
  };

  //   showing multiple
  // useEffect(() => {
  //     if (OrdersStatus?.success === true) {
  //         toast(OrdersStatus?.message)
  //         dispatch(fetchOrders({ userId: userDetail?.data?._id }));
  //         dispatch(cleanOrdersStatus())
  //     }
  // }, [OrdersStatus]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="card card-shadow border-0 h-100 position-relative">
      <div className="dropdown dropdown-new d-flex justify-content-center three_dots">
        <button
          type="button"
          className="btn px-2 dropdown-action bg-drop px-0  border-0"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <BsThreeDotsVertical className="" />
        </button>
        <ul className="dropdown-menu dropdown-menu-end px-2 dropdown-menu-width">
          {bookingStatus === "returned" && (
            <li
              className="align-items-center d-flex gap-2 btn "
              onClick={() => approveHandler(bookingId)}
            >
              <FaCheckCircle className="edit-icon-fav clr-theme fs-5" />{" "}
              <span className="f14"> Approved</span>
            </li>
          )}
          <li
            className="align-items-center d-flex gap-2 btn "
            onClick={() => bookingSummaryModal(bookingData)}
          >
            <FaEye className="edit-icon-fav clr-theme fs-5" />{" "}
            <span className="f14"> View</span>
          </li>
          {/* <li className="text-center mb-2"><FaTrashAlt className='trash-icon-fav fs-5' onClick={() => carDeleteHandle(carId)} /></li> */}
        </ul>
      </div>
      <div className="bg-transparent border-0 card-header p-0">
        <img
          src={`${baseURL}${carImage}`}
          className="fav-img rounded-top"
          alt="car-image"
        />
      </div>
      <div className="card-body px-2">
        <div className="">
          <div className="d-flex flex-column justify-content-evenly align-items-start">
            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
              <h3 className="card-title font text-capitalize">{carName}</h3>
            </div>
            <div className="align-items-center d-flex mb-2 gap-2">
              <div className=" fs14 ">Booking id:</div>
              <p className="m-0 f14 text-secondary f13">{bookingId}</p>
            </div>
            <div className="f13 mb-2 align-items-center d-flex gap-1">
              <FaLocationDot className="clr-theme min-width-icon fs-6" />
              {carLocation}
            </div>
            <div className="d-flex justify-content-between align-items-center w-100">
              {/* <div>
                                <div className='text-secondary fs14 f12'>
                                    <small>Trip start</small>
                                </div>
                                <p className='m-0 f12'>{formattedStartDate.date} {formattedStartDate.time}</p>
                            </div>
                            <div>
                                <div className='text-secondary fs14 f12'>
                                    <small>Trip end</small>
                                </div>
                                <p className='m-0 f12'>{formattedEndDate.date} {formattedEndDate.time}</p>
                            </div>
                            <div>
                                <div className='text-secondary fs14 f12'>
                                    <small>paid</small>
                                </div>
                                <p className='m-0 f12'>K{carPrice}</p>
                            </div> */}
              <div className="align-items-center d-flex gap-1">
                <MdOutlinePaid className="min-width-icon clr-theme fs-6" />

                <p className="m-0 f13">K{carPrice}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={isModalVisible} onHide={() => setModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="font accentColor-imp">
            Booking Summary
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <h5 className="mb-2 accentColor">User Information</h5>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Name</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {bookingDataModal?.user?.name}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Phone Number</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {bookingDataModal?.user?.phoneNumber}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Address</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {bookingDataModal?.user?.address}
                </span>
              </p>
              <hr />
              <h5 className="mb-2 accentColor">Car Information</h5>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Car Name</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {bookingDataModal?.car?.maker?.carMake}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Booking Status</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {bookingDataModal?.paymentStatus}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Pick up Location</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {bookingDataModal?.car?.carLocation}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">
                  Pick up date & time
                </span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {formattedStartDate.date} {formattedStartDate.time}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Return date & time</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {formattedEndDate.date} {formattedEndDate.time}
                </span>
              </p>
              <hr />
              <h6 className="mb-2 accentColor">Transaction Information</h6>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Per day car rent</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  K{bookingDataModal?.car?.pricePerDay}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">
                  Total {bookingDataModal?.noOfBookingDays} day rent
                </span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  {" "}
                  K
                  {bookingDataModal?.totalAmount *
                    bookingDataModal?.noOfBookingDays}
                </span>
              </p>
              <p className="d-flex justify-content-between mb-1">
                <span className="col-5 fw-medium fs14">Total payment</span>
                <span className="col-1">:</span>
                <span className="col-5 text-secondary fs14">
                  K{" "}
                  {bookingDataModal?.totalAmount *
                    bookingDataModal?.noOfBookingDays}
                </span>
              </p>
            </div>

            {/* <Modal.Body>
                    <p><span className='modal-key'> Car Name:</span> {bookingDataModal?.car?.maker?.carMake}</p>
                    <p><span className='modal-key'> Booking Status:</span> {bookingDataModal?.paymentStatus}</p>
                    <p><span className='modal-key'> Pick up Location:</span> {bookingDataModal?.car?.carLocation}</p>
                    <p><span className='modal-key'> Pick up date & time:</span> {formattedStartDate.date} {formattedStartDate.time}</p>
                    <p><span className='modal-key'> Return date & time:</span> {formattedEndDate.date} {formattedEndDate.time}</p>
                    <p><span className='modal-key'> Per day car rent:</span> K{bookingDataModal?.car?.pricePerDay}</p>
                    <p><span className='modal-key'> Total 2 day rent:</span> K{bookingDataModal?.totalAmount}</p>
                    <p><span className='modal-key'> Total payment:</span> K{bookingDataModal?.amount}</p> */}
            {/* </Modal.Body > */}
          </div>
        </Modal.Body>
      </Modal>
      {/* {isModalVisible && (
                <div className='row' >
                    <div className='col-md-4' >
                        <div className='filter-btn' >
                            <div className="modal fade" id="filterModal" tabIndex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h1 className="modal-title fs-5" id="filterModalLabel">Summary</h1>
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <p>Booking Status:</p>
                                            <p>Pick up Location:</p>
                                            <p>Pick up date & time:</p>
                                            <p>Return date & time:</p>
                                            <p>Per day car rent:</p>
                                            <p>Total 2 day rent:</p>
                                            <p>Total payment:</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
    </div>
  );
};

export default OrdersCard;
